import { TemplateSettings } from '../store/interfaces';
import { BrandColors } from './brandColors';
import { eventConfig } from './eventConfig';

export const defaultBranding: TemplateSettings = {
  requiresLogin: false,
  utilityBar: {
    backgroundColor: BrandColors.white,
    textColor: BrandColors.grey20,
    logo: null,
  },
  event: eventConfig,
  links: [
    {
      label: '',
      url: '',
    },
    {
      label: '',
      url: '',
    },
    {
      label: '',
      url: '',
    },
  ],
  footer: {
    backgroundColor: BrandColors.grey40,
    textColor: BrandColors.white,
    helpButton: {
      fillColor: BrandColors.white,
      outlineColor: BrandColors.grey40,
      textColor: BrandColors.grey40,
      hoverFillColor: BrandColors.grey40,
      hoverOutlineColor: BrandColors.grey40,
      hoverTextColor: BrandColors.white,
      text: 'Get Help',
    },
  },
  page: {
    containerColor: BrandColors.white,
    backgroundColor: BrandColors.white,
    backgroundImage: null,
    fontType: 'Open Sans',
    fontColor: BrandColors.grey20,
    buttonStyle1: {
      fillColor: BrandColors.grey20,
      outlineColor: BrandColors.grey20,
      textColor: BrandColors.white,
      hoverFillColor: BrandColors.white,
      hoverOutlineColor: BrandColors.grey20,
      hoverTextColor: BrandColors.grey20,
    },
    buttonStyle2: {
      fillColor: BrandColors.white,
      outlineColor: BrandColors.grey20,
      textColor: BrandColors.grey20,
      hoverFillColor: BrandColors.grey20,
      hoverOutlineColor: BrandColors.grey20,
      hoverTextColor: BrandColors.white,
    },
    timeline: {
      lineColor: BrandColors.lightGreenColor,
      iconContainerColor: BrandColors.white,
      iconColor: BrandColors.grey20,
    },
    flexibleBanner: false,
  },
  otherElements: {
    svgStyles: {
      stroke: 'none',
      fill: BrandColors.white,
      fillForElements: '#273950',
    },
    basicTaskListIcons: {
      lockAndCompleted: {
        color: BrandColors.grey100,
      },
    },
    passwordStrengthMeter: {
      weak: { color: BrandColors.grey77 },
      medium: { color: BrandColors.red39 },
      strong: { color: BrandColors.green20 },
      border: 'none',
    },
    alert: {
      outlinedInfo: {
        background: BrandColors.grey95,
        border: `1px solid ${BrandColors.grey77}`,
      },
      outlinedInfoTransparent: {
        border: `1px solid ${BrandColors.grey77}`,
      },
      outlinedError: {
        background: BrandColors.lightRed39,
        border: `1px solid ${BrandColors.red39}`,
      },
      outlinedSuccess: {
        background: BrandColors.grey95,
        border: `1px solid ${BrandColors.grey20}`,
      },
    },
    MuiSvgIcon: {
      iconColor: BrandColors.blackWithOpacity765,
    },
    divider: {
      backgroundColor: BrandColors.grey88,
    },
    MuiInputBase: {
      backgroundColor: BrandColors.white,
    },
    error: {
      color: BrandColors.red39,
    },
    MuiLink: {
      color: BrandColors.muiLink,
    },
    PlaceHolder: {
      color: BrandColors.grey33,
    },
    disabledColor: BrandColors.grey14,
    border: 'none',
    borderColor: BrandColors.borderGrey,
    borderColorInputField: BrandColors.inputBorderColor,
    ProgressIconColor: {
      fillColor: BrandColors.white,
      strokeColor: '#E0E1E0',
    },
    dialogBox: {
      primaryColor: BrandColors.white,
      secondaryColor: BrandColors.black,
      border: 'none',
      opacity: 0.85,
    },
    success: {
      color: BrandColors.passwordValidationSuccess,
    },
    MuiButton: {
      disabledBackgroundColor: BrandColors.grey95,
      disabledTextColor: BrandColors.grey33,
    },
    iconHover: {
      background: BrandColors.grey90,
    },
  },
};
